import React from 'react';
import { motion } from 'framer-motion';
import { Building2, Landmark, CreditCard, BadgeDollarSign, Building } from 'lucide-react';
export function TrustBar() {
  const logos = [{
    name: 'SBA',
    icon: Landmark
  }, {
    name: 'IRS',
    icon: Building2
  }, {
    name: 'Chase',
    icon: Building
  }, {
    name: 'Amex',
    icon: CreditCard
  }, {
    name: 'Bank of America',
    icon: BadgeDollarSign
  }];
  return <section className="py-5 md:py-8 bg-[#0a0e1a] relative overflow-hidden" data-id="element-181">
      {/* Gold accent borders */}
      <div className="absolute top-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-gold/40 to-transparent" data-id="element-182" />
      <div className="absolute bottom-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-gold/40 to-transparent" data-id="element-183" />

      {/* Warm gold ambient glow */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-gold/[0.04] via-transparent to-transparent" data-id="element-184" />

      <div className="max-w-6xl mx-auto px-3 text-center relative z-10" data-id="element-185">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex items-center justify-center gap-2 mb-4" data-id="element-186">
          <div className="h-[1px] w-8 bg-gradient-to-r from-transparent to-gold/50" data-id="element-187" />
          <p className="text-[10px] sm:text-xs font-heading font-semibold text-gold/70 uppercase tracking-[0.2em]" data-id="element-188">
            Basado en protocolos oficiales del sistema americano
          </p>
          <div className="h-[1px] w-8 bg-gradient-to-l from-transparent to-gold/50" data-id="element-189" />
        </motion.div>

        <div className="flex justify-center items-center gap-3 sm:gap-6 md:gap-8" data-id="element-190">
          {logos.map((logo, index) => <motion.div key={logo.name} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08,
          duration: 0.3
        }} className="flex items-center gap-1.5 sm:gap-2 px-2 py-1.5 sm:px-3 sm:py-2 rounded-lg border border-white/[0.06] bg-white/[0.02]" data-id="element-191">
              <logo.icon className="w-3.5 h-3.5 sm:w-4 sm:h-4 md:w-5 md:h-5 text-gold/50 flex-shrink-0" strokeWidth={1.5} data-id="element-192" />
              <span className="font-heading font-bold text-[10px] sm:text-xs md:text-sm text-white/50 tracking-wide" data-id="element-193">
                {logo.name}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}